import React, { useMemo } from 'react';
import { InlineSelect } from '../../InlineTable';
import { Segmented } from '../kit';

const SCOPE_OPTIONS = [
  { value: 'global', label: 'All organizations' },
  { value: 'org', label: 'An organization' },
  { value: 'location', label: 'A property' },
];

/**
 * Scope: all organizations / one organization / one property, with name
 * pickers. Picking a property also records its organization (the store keeps
 * both). `lookups` comes from skillsApi.loadScopeLookups.
 */
export default function ScopePicker({ draft, onChange, lookups, disabled }) {
  const orgOptions = lookups?.orgOptions || [];
  const locationOptions = useMemo(() => {
    const all = lookups?.locationOptions || [];
    return draft.orgId != null && draft.scopeType === 'location'
      ? all.filter((l) => l.orgId === draft.orgId)
      : all;
  }, [lookups, draft.orgId, draft.scopeType]);

  const setType = (scopeType) => {
    if (scopeType === 'global') onChange({ scopeType, orgId: null, locationId: null });
    else if (scopeType === 'org') onChange({ scopeType, locationId: null });
    else onChange({ scopeType });
  };

  return (
    <div className="sk-scope">
      <Segmented
        mode="choice"
        label="Scope"
        options={SCOPE_OPTIONS}
        value={draft.scopeType}
        onChange={setType}
        disabled={disabled}
      />
      {draft.scopeType !== 'global' ? (
        <div className="sk-scope-pickers">
          <div className="sk-picker">
            <InlineSelect
              rowActive
              ariaLabel="Organization"
              placeholder={!orgOptions.length ? 'Organizations unavailable'
                : draft.scopeType === 'location' ? 'Any organization (narrows the property list)' : 'Choose an organization…'}
              options={orgOptions}
              value={draft.orgId}
              disabled={disabled}
              clearable={draft.scopeType === 'location'}
              onChange={(v) => {
                const orgId = v == null ? null : Number(v);
                const loc = draft.locationId != null ? lookups?.locations?.get(draft.locationId) : null;
                onChange({ orgId, locationId: loc && loc.orgId !== orgId ? null : draft.locationId });
              }}
            />
          </div>
          {draft.scopeType === 'location' ? (
            <div className="sk-picker">
              <InlineSelect
                rowActive
                ariaLabel="Property"
                placeholder={locationOptions.length ? 'Choose a property…' : 'No properties'}
                options={locationOptions}
                value={draft.locationId}
                disabled={disabled}
                clearable={false}
                onChange={(v) => {
                  const locationId = v == null ? null : Number(v);
                  const loc = locationId != null ? lookups?.locations?.get(locationId) : null;
                  onChange({ locationId, orgId: loc?.orgId ?? draft.orgId });
                }}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
